import React, { useCallback } from "react";
import Grid from "@mui/material/Grid";

import { TextField } from "@mui/material";

export default function Uc({ UC, handleInputChange, FORM_MODE }) {
  // const handleChange = (field, newVal) => {
  //   handleInputChange("UC", { ...UC, [field]: newVal });
  // };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          // disabled
          name="UC_OrganisationNumber"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="OrgNr"
          value={UC.UC_OrganisationNumber}
          onChange={(e) =>
            handleInputChange("UC_OrganisationNumber", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          // disabled
          name="UC_NumberOfComplaints"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Anmärkningar"
          value={UC.UC_NumberOfComplaints}
          onChange={(e) =>
            handleInputChange("UC_NumberOfComplaints", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          // disabled
          name="UC_CreateTime"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="UC Skapad"
          value={UC.UC_CreateTime}
          onChange={(e) => handleInputChange("UC_CreateTime", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          // disabled
          name="UC_Status"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="UC Status"
          value={UC.UC_Status}
          onChange={(e) => handleInputChange("UC_Status", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
          
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          // disabled
          name="UC_Message"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="UC Meddelande"
          value={UC.UC_Message}
          onChange={(e) => handleInputChange("UC_Message", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

    </Grid>
  );
}
